export default "__VITE_ASSET__03rre8BG__"